export default "__VITE_ASSET__BbVAWQPh__"